import React, { Component } from 'react';

import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { connect } from 'react-redux';
import { openDrawer, closeDrawer } from 'actions/drawer';
import { openModal } from 'actions/modal';
import Footer from 'components/AppFooter/AppFooter';

import { firebaseConnect, helpers } from 'react-redux-firebase';
const { isLoaded, dataToJS, pathToJS } = helpers;

import SupplementalMaterialsList from 'components/SupplementalMaterialsList';
import ContentHeader from 'components/ContentHeader';
import Input from 'components/Input';
import Button from 'components/Button';
import ClassroomPanel from 'components/ClassroomPanel';
import Loader from 'components/Loader/Loader';
import Tabs from 'components/Tabs';

import { keyedObjToArr } from '../../util';


class SupplementalMaterials extends Component {

	render () {

        if( !isLoaded(this.props.profile) ||
            !isLoaded(this.props.products) ||
            !isLoaded(this.props.customers) ||
            !isLoaded(this.props.orders) ||
            !isLoaded(this.props.users)
        ) {
            return (
				<div className="main-content-area">
					<div className="page-content">
						<Loader color="main" size="large" />
					</div>
					<Footer/>
				</div>
            );
        }

		return (
			<ReactCSSTransitionGroup
				transitionName="main-content"
				transitionAppear={true}
				transitionAppearTimeout={1500}
				transitionEnterTimeout={1500}
				transitionLeaveTimeout={1500}
				className="main-transition-wrap"
			>
			<div className="main-content-area" key="classrooms">
				<ContentHeader
					title="Supplemental Materials"
				/>
				<div className="page-content">
					<div className="container">
						<div className="row">
							<div className="col-12">
								<div className="main-list-area">
									<SupplementalMaterialsList
										profile={this.props.profile}
										customer={this.props.customers}
										products={this.props.products}
										orders={this.props.orders}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			</ReactCSSTransitionGroup>
		);
	}
}

const fbWrappedComponent = firebaseConnect( ({auth, profile}) => {

	if(!profile){
		return [];
	} else if (profile.customer) {
		return [
			{
				path: 'users',
				storeAs: 'users',
				queryParams: [ `orderByChild=customer`, `equalTo=${profile.customer}`]
			},
			{
				path: 'customers/'+profile.customer,
				storeAs: 'customers'
			},
			{
				path: 'orders',
				storeAs: 'orders',
				queryParams: [ `orderByChild=customer`, `equalTo=${profile.customer}`]
			},
			{
				path: 'products',
				storeAs: 'products'
			}
		];;
	} else if (profile.role === 'admin'){
		return [
			{
				path: 'users',
				storeAs: 'users'
			},
			{
				path: 'customers',
				storeAs: 'customers'
			},
			{
				path: 'orders',
				storeAs: 'orders'
			},
			{
				path: 'products',
				storeAs: 'products'
			}
		];;
	}

})(SupplementalMaterials);

//Auth
const connectAuth = connect(
	({ firebase }) => {
		return{
			profile: pathToJS(firebase, 'profile'),
		};
	}
)(fbWrappedComponent);

//Export
export default connect(
	({ firebase }) => ({
		customers: dataToJS(firebase, 'customer'),
		products: dataToJS(firebase, 'products'),
		users: dataToJS(firebase, 'users'),
		orders: dataToJS(firebase, 'orders')
	})
)(connectAuth);





// WEBPACK FOOTER //
// ./js/containers/SupplementalMaterials/SupplementalMaterials.js